import { useState, useCallback } from "react";
import { Flex } from "@chakra-ui/react";
import { MotionBox as Box, viewAppearDefault } from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";
import Button from "components/base/Button";
import ModalVideo from "components/sections/ModalVideo";
import PlayCircleIcon from "components/icons/PlayCircleIcon";
import HeroVideoHeader from "components/sections/HeroVideoHeader";
import Trans from "components/base/Trans";

const opacityVariants = {
  open: { opacity: 0, transition: { type: "tween", duration: 0.4 } },
  closed: {
    opacity: 1,
    transition: { ease: [0.01, 0.01, 0.4, 1], duration: 1.2 },
  },
};

const VideoSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const callbackOpenModal = useCallback(
    () => setIsOpenModal(!isOpenModal),
    [isOpenModal],
  );

  return (
    <>
      <HeroVideoHeader
        height="100vh"
        videoSrc="https://filecdn.hillhelicopters.com/website-videos/imagine-preview.mp4"
        image="/images/team/team-video.jpg"
        mobileImage="/images/team/team-video.jpg"
        noScrollHint
      />
      <Container
        id="presentation"
        pt={[6, null, 20, 20, 20]}
        pb="lg"
        position="absolute"
        top={0}
        height="100vh"
        minHeight="600px"
        maxWidth="xl"
      >
        <Box
          bg="rgba(0,0,0, 0.9)"
          position="absolute"
          h="100%"
          w="200vw"
          top="0%"
          left="-100vw"
          animate={!isOpen ? "open" : "closed"}
          variants={opacityVariants}
          onClick={() => setIsOpen(false)}
        />
        <Flex align="flex-end" h="100%">
          <Flex
            justify="space-between"
            w="100%"
            gap={[4, 10]}
            direction={["column-reverse", "column-reverse", "row"]}
          >
            <Flex align="flex-end">
              <Box
                variants={viewAppearDefault}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 1 }}
              >
                <Button
                  bg="white"
                  color="black"
                  borderRadius="none"
                  mb={[4, null, 8]}
                  _hover={{ bg: "gray.200" }}
                  _active={{ bg: "gray.300" }}
                  onClick={callbackOpenModal}
                >
                  <Flex align="center">
                    <Text fontWeight="bold" mr={2} color="black.700">
                      <Trans id="LBL_TEAM_VIDEO_CTA" />
                    </Text>
                    <PlayCircleIcon />
                  </Flex>
                </Button>
              </Box>
            </Flex>
            <Box
              mb={[8, null, 24]}
              variants={viewAppearDefault}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 1 }}
              w={["280px", null, "420px"]}
            >
              <Text
                fontSize={["22px", null, "24px", "32px"]}
                style={{
                  fontStyle: "oblique",
                  lineHeight: 1.5,
                  color: "white",
                }}
              >
                <Trans id="LBL_TEAM_VIDEO_TITLE" />
              </Text>
              <Text type="p_md" color="white" pt={[2, null, 8]}>
                <Trans id="LBL_TEAM_VIDEO_SUBTITLE" />
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Container>
      <ModalVideo
        isOpen={isOpenModal}
        onClose={callbackOpenModal}
        videoId="NredReGJiyE"
      />
    </>
  );
};

export default function TeamVideoSection() {
  return (
    <Flex
      position="relative"
      bg="black.900"
      minHeight="600px"
      h="100vh"
      justify="center"
    >
      <Box maxW="xl" w="100%" h="100vh" position="absolute">
        <VideoSection />
      </Box>
    </Flex>
  );
}
